/**
 * PrintBrandHeader — Header de marque pour le print/PDF.
 *
 * LOT Public Design B (Daniel 18/06/2026) — Fondation print commune.
 *
 * Affiché UNIQUEMENT en print/PDF (la règle CSS `.wm-print-only` est
 * `display: none` en écran et `display: flex` en `@media print`).
 *
 * Donne une identité de marque propre sur la page 1 de CHAQUE page
 * publique imprimée, sans répéter le header sticky écran sur toutes
 * les pages du PDF.
 *
 * Injecté une seule fois dans `PublicLayout.js` → bénéficie
 * automatiquement à toutes les pages publiques (`/fr`, `/fr/a-propos`,
 * `/fr/comment-ca-marche`, `/fr/creer-spv`, `/fr/demander-acces`,
 * `/fr/contact`, `/fr/connexion`, `/fr/avertissement-risques`, etc.)
 * et leurs équivalents `/en/...`.
 *
 * Variante `light` (logo doré sur fond clair) car le fond imprimé
 * standard est ivory/blanc.
 */
import WMLogo from './brand/WMLogo';

export default function PrintBrandHeader() {
  return (
    <div
      className="wm-print-only print-brand-header"
      data-testid="print-brand-header"
      aria-hidden
    >
      <WMLogo variant="light" mode="horizontal" size="md" />
    </div>
  );
}
